import {isCordova} from "../utils/isCordova";

const getBaseUrl = () => {
	let baseUrl = window.location.origin;

	if (isCordova()) {
		baseUrl = 'https://api.logrx.com';
		if (localStorage.useSandbox) {
			baseUrl = 'https://dev.logrx.com';
		}
	}
	return baseUrl;
};
export default getBaseUrl;